import { TemplateRef } from "@angular/core";

export class Tab {
  tabId?: string = undefined;
  tabTitle?: string = undefined;
  tabIcon?: string = undefined;
  tabClass?: string = undefined;
  icon?: string = undefined;
  link?: string = undefined;
  action?: string;
  isActive?: boolean = undefined;
  disabled?: boolean = undefined;
  current?: boolean;
  onSelect?: Function;
  onUnSelect?: Function;
  onMouseEnter?: Function;
  onMouseLeave?: Function;
  isHidden?: boolean;
  hFull?: boolean;
  subMenu?: TemplateRef<any>;
  tabBadgeCounter?: number;
  tabBadgeColor?: string;
  img?: string = undefined;
  badge?: number;
}

export class TabIdList {
  MNG__CLINICS = "mng.clinics";
  MNG__USERS = "mng.users";
  MNG__PARAMS = "mng.params";
  MNG__DR_PROFILE = "mng.dr_profile";
  KPI__BROSH = "kpi.brosh";
  KPI__CLINICS = "kpi.clinics";
  KPI__AGENTS = "kpi.agents";
}

export const tabList = Object.freeze(new TabIdList());
